<template>
  <div>
    <p class="text-center">
      <strong>Slots de publicaciones disponibles (Coches.net)</strong>
    </p>
    <div class="row">
      <!-- class="col-lg-6 col-md-6 col-sm-6 col-xs-12" -->
      <div
        class="col-lg-3 col-md-6 col-sm-6 col-xs-12"
        v-for="quota in this.$store.state.app.carfactoryDealerQuota"
        v-bind:key="quota.id">
        <div class="progress-group">
          <span class="progress-text">{{ quota.name.toUpperCase() }}</span>
          <span class="progress-number"><b>{{quota.current}}</b>/{{quota.max}}</span>
        </div>
        <!-- <div style="width: 300px">
          <apexchart type="pie" width="300px" :options="getChartOptions(quota)" :series="getSeries(quota)" />
        </div> -->
        <div style="display: block; width: 100%; min-height: 250px;">
          <div style="width: 100%; display: inline-block;">
            <apexchart type="pie" :style="{width: '80%', minWidth: '200'}" :options="getChartOptions(quota)" :series="getSeries(quota)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const colors = {
  'Sin usar': '#6f7171',
  Nuevo: '#008ffb',
  Km0: '#00e396',
  'Sustitución': '#00e396',
  Gerencia: '#00e396',
  'Demostración': '#00e396',
  'Ocasión': '#00e396'
}
export default {
  name: 'CarfactoryDealerQuotaComponent',

  mounted () {
    this.$store.dispatch('app/syncCarfactoryDealerQuota')
  },

  methods: {
    getChartOptions (quota) {
      const labels = [...quota.types.map(q => q.name), 'Sin usar']
      return {
        labels,
        colors: labels.map((l) => colors[l])
      }
    },
    getSeries: (quota) => [...quota.types.map(q => parseInt(q.cars)), Math.max((quota.max - quota.current), 0)]
  },

  computed: {
    computedProperty () {
      if (this.$store.getters['app/hasRole']('ROLE_ADMIN')) {
        let carfactoryDealerQuotes = this.$store.state.app.carfactoryDealerQuota
        let offsetCurrent = 0
        let offsetMax = 0
        for (let k in carfactoryDealerQuotes) {
          if (carfactoryDealerQuotes.hasOwnProperty(k)) {
            let carfactoryDealerQuota = carfactoryDealerQuotes[k]
            offsetCurrent += carfactoryDealerQuota.current
            offsetMax += carfactoryDealerQuota.max
          }
        }
        return offsetMax > 0 ? ` • (${offsetCurrent} / ${offsetMax})` : ''
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
  .progress-text {
    font-size: 0.85em;
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/custom/CarfactoryDealerQuotaComponent.vue